import { deleteWarrantyCoverage } from "actions/Utilities/WarrantyCoverage";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { warrantyCoverageReFetching } from "../atoms/atoms";

export default function useDeleteWarranty() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    warrantyCoverageReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteWarrantyCoverage(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Warranty Coverage failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Warranty Coverage Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Warranty Coverage Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Warranty Coverage failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Warranty Coverage not found":
              toast.fire(
                "Disabling Warranty Coverage failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Warranty Coverage failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Warranty Coverage failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
